import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import { withTranslation } from '@wix/yoshi-flow-editor';

import NavArrow from './images/prev.svg';

import styles from './nav-button.scss';

const navTranslations = {
  next: 'shared.navigation.next-page',
  prev: 'shared.navigation.previous-page',
};

class GenericNavButton extends React.Component {
  static propTypes = {
    name: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
    ariaLabel: PropTypes.string.isRequired,
    disabled: PropTypes.bool,
  };

  static defaultProps = {
    rounded: false,
  };

  render() {
    const { name, disabled, ariaLabel, onClick } = this.props;

    const classNames = classnames(styles['nav-button'], styles[name], {
      [styles.disabled]: disabled,
    });

    return (
      <button
        className={classNames}
        type="button"
        onClick={disabled ? null : onClick}
        aria-label={ariaLabel}
      >
        <NavArrow className={styles['nav-arrow']} />
        <div className={styles['nav-text']}>
          {this.props.t(navTranslations[name])}
        </div>
      </button>
    );
  }
}

export const PrevButton = withTranslation()((props) => {
  return (
    <GenericNavButton
      {...props}
      ariaLabel={props.t('widget.accessibility.prev-videos')}
      name="prev"
    />
  );
});

export const NextButton = withTranslation()((props) => {
  return (
    <GenericNavButton
      {...props}
      ariaLabel={props.t('widget.accessibility.next-videos')}
      name="next"
    />
  );
});
